import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Image,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/Button";
import skipgiveLogo from "../assets/skipgive-logo.png";

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      bg="linear-gradient(135deg, #e3f2fd 0%, white 50%, #f8fafc 100%)"
      minH="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Container maxW="2xl" py={10}>
        <VStack spacing={8} align="center" textAlign="center">
          <Image
            src={skipgiveLogo}
            alt="SkipGive"
            maxW="250px"
            mb={4}
          />

          <Heading
            size="4xl"
            color="#339CFF"
            fontWeight="800"
            letterSpacing="-2px"
          >
            404
          </Heading>

          <Heading size="xl" color="#1A202C">
            Page Not Found
          </Heading>

          <Text
            fontSize="lg"
            color="#4a5568"
            maxW="md"
            lineHeight="tall"
          >
            Oops! The page you're looking for doesn't exist. It might have been
            moved or deleted.
          </Text>

          <VStack spacing={3} pt={4}>
            <Button
              buttonType="primary"
              label="Go to Homepage"
              onClick={() => navigate("/")}
            />
            <Button
              buttonType="secondary"
              label="Go Back"
              onClick={() => navigate(-1)}
            />
          </VStack>
        </VStack>
      </Container>
    </Box>
  );
};
